export const WHITEBOARD_BASE_SIZE = {
  width: 1280,
  height: 720
}

export const VIDEO_CONSTRAINS = {
  qvga: { width: { ideal: 160 }, height: { ideal: 120 } },
  vga: { width: { ideal: 320 }, height: { ideal: 240 } },
  hd: { width: { ideal: 480 }, height: { ideal: 360 } }
}

export const PC_PROPRIETARY_CONSTRAINTS = {
  optional: [ { googDscp: true } ]
}

export const WEBCAM_SIMULCAST_ENCODINGS = [
  { scaleResolutionDownBy: 8, maxBitrate: 100000 },
  { scaleResolutionDownBy: 2, maxBitrate: 1000000 },
  { scaleResolutionDownBy: 1, maxBitrate: 5000000 }
]

export const WEBCAM_KSVC_ENCODINGS = [
  { scalabilityMode: 'S3T3_KEY' }
]
